import React from 'react'

import { Fade } from "react-reveal";

const WorkExperience = () => {
  return (
    <div
      name="work_experiene"
      className="w-full h-100 bg-gradient-to-b from-gray-800 to-black text-white about1  "
    >
      <Fade top duration={1000} distance="40px">
        <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
          <div className="pb-8">
            <p className="text-4xl font-bold inline border-b-4 border-gray-500">
              Work Experience
            </p>
          </div>
          <Fade top duration={1000} distance="40px">
            <p className="text-xl mt-5">
              Full Stack Developer
              <br />
              actyv.ai, Bengaluru
              <br />
              <p className="italic text-[16px]">Nov 2022 - Aug-23</p>
            </p>
          </Fade>
          <br />
          <Fade top duration={1000} distance="40px">
            <p className="text-xl">
              <p className="text-gray-400 italic">Achievements/asks</p>
              <br />
              <ul className="list-disc ml-5 flex flex-col gap-3">
                <li>
                  Solely built UI for a actyv score product used by 46,000 business
                  partners.
                </li>
                <li>Developed npm packages for reusable React components, promoting
                code consistency.</li> 
                
                <li>Created enterprise dashboards for clients such
                as TATA, Adani, and Nivia.</li> 
                
                <li>Implemented RESTful APIs contributing
                to actyv retailer scores. </li>
                
                <li>Worked on APIs to facilitate smooth
                business partner onboarding.</li> 
                
                <li>Collaborated closely with the data
                science team to integrate machine learning models for generating
                actyv scores.</li> 
                
                <li>Ensured product quality through rigorous testing
                and debugging.</li> 
                
                <li>Actively engaged with clients for requirements
                gathering and feedback.</li> 
                
                <li>Collaborated with cross-functional teams
                and remained updated with industry trends.</li>
              </ul>
              <br />
              {/* An experienced Full-Stack web developer with an enduring passion
              for continuous learning. Proficient in both leadership and
              teamwork, I am eagerly seeking opportunities to craft innovative
              solutions that enhance people's lives. I aspire to become an
              indispensable asset within an organization that nurtures my
              professional growth. I'm a passionate Developer with strong
              administrative and communication skills, good attention to detail
              and the ability to write efficient code using MERN Stack.
              <br /> <br />
              As I grow and flourish as a Developer, one thing which keeps me
              going is my inquisitiveness for discovering new things every day.
              <br /> <br /> */}
            </p>
          </Fade>
        </div>
      </Fade>
    </div>
  );
}

export default WorkExperience